import { dataUserStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserStarSolid = /*#__PURE__*/createIcon(dataUserStarSolid)
export default IconUserStarSolid
